module.exports = "<span data-ng-message=required>*An asset type is required</span> ";